import { put, select } from 'redux-saga/effects';
import nsApi from '@netsapiens/netsapiens-js/dist/api';
import nsUtils from '@netsapiens/netsapiens-js/dist/utils';

import * as actions from '../../../state';
// eslint-disable-next-line import/no-cycle
import store from '../../../store';

export default function* forgotPassword(event) {
  yield put(actions.showLoaderPage());

  const apiHash = yield select((state) => state.configs.apiHash);

  const { login } = event.payload;

  try {
    // const params = {
    //   login,
    //   apiHash,
    // };

    const decodedApiHash = nsUtils.encoding.base64Decode(apiHash);
    const clientId = decodedApiHash.split(':');

    const data = {
      object: 'email',
      action: 'create',
      subject: 'Your Password Recovery',
      template: 'password_reset_email.php',
      // eslint-disable-next-line no-restricted-globals
      app_uri: `${location.origin}/analytics/reset/<USERNAME>/<AUTH_CODE>`,
      username: login,
      client_id: clientId,
    };

    nsApi.post(data).then((res) => {
      if (res.sent) {
        store.dispatch(actions.loginFormSuccessMsg('An email has been sent to the specified address.'));
        store.dispatch(actions.showLoginFormPage());
      } else {
        store.dispatch(actions.loginFormErrorMsg(
          'There was a problem retrieving your account. Please contact your administrator.',
        ));
        store.dispatch(actions.showForgotPasswordPage());
      }
    }).catch(() => {
      store.dispatch(actions.loginFormErrorMsg(
        'There was a problem retrieving your account. Please contact your administrator.',
      ));
      store.dispatch(actions.showForgotPasswordPage());
    });
  } catch (err) {
    store.dispatch(actions.loginFormErrorMsg(
      'There was a problem retrieving your account. Please contact your administrator.',
    ));
    store.dispatch(actions.showForgotPasswordPage());
  }
}
